<ion-header style="text-align: center;justify-content: center;">
  <h1>{{ 'VacationAlert' | translation }}</h1>
</ion-header>

<ion-content style="text-align: center;">
  <p>{{ 'OnVacation' | translation }}</p>
  <ion-button (click)="switch()">{{ 'Switch' | translation }}</ion-button>
</ion-content>
